/**
 * Data peta dari unggahan CSV (localStorage).
 * Format: kolom desa (wajib), nilai (wajib), kecamatan (opsional).
 */

import { normalizeForMatch as normMap } from './mapGeoMerge';

export const MAP_CSV_STORAGE_KEY = 'tulufali_map_csv_v1';
export const MAP_CSV_CHANGED_EVENT = 'tulufali-map-csv-changed';

function normalizeHeader(h) {
  return String(h || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_');
}

/**
 * @returns {{ desa: string, kecamatan: string, nilai: number }[]}
 */
export function loadMapCsvRows() {
  try {
    const raw = localStorage.getItem(MAP_CSV_STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveMapCsvRows(rows) {
  const clean = (Array.isArray(rows) ? rows : [])
    .map((r) => Object.assign({}, r))
    .filter((r) => r && String(r.desa || '').trim());
  localStorage.setItem(MAP_CSV_STORAGE_KEY, JSON.stringify(clean));
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(MAP_CSV_CHANGED_EVENT));
  }
}

export function clearMapCsvData() {
  localStorage.removeItem(MAP_CSV_STORAGE_KEY);
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(MAP_CSV_CHANGED_EVENT));
  }
}

/**
 * Parse teks CSV sederhana (koma/tab; baris pertama header).
 */
export function parseMapCsvText(text) {
  const lines = String(text || '')
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter(Boolean);
  if (lines.length < 2) return [];

  const delim = lines[0].includes('\t') && !lines[0].includes(',') ? '\t' : ',';
  const headers = lines[0].split(delim).map((h) => normalizeHeader(h.replace(/^"|"$/g, '')));

  const idxDesa = headers.findIndex((h) => h === 'desa' || h === 'village' || h === 'nama_desa');
  const idxKec = headers.findIndex((h) => h === 'kecamatan' || h === 'district' || h === 'kec');
  const idxNilai = headers.findIndex(
    (h) => h === 'nilai' || h === 'value' || h === 'jumlah' || h === 'total' || h === 'angka'
  );
  if (idxDesa < 0 || idxNilai < 0) {
    throw new Error('CSV harus punya kolom desa dan nilai (header: desa, nilai).');
  }

  const rows = [];
  for (let i = 1; i < lines.length; i++) {
    const cells = lines[i].split(delim).map((c) => c.replace(/^"|"$/g, '').trim());
    const desa = cells[idxDesa] || '';
    const kecamatan = idxKec >= 0 ? cells[idxKec] || '' : '';
    const rawVal = cells[idxNilai];
    const nilai = parseFloat(String(rawVal).replace(',', '.')) || 0;
    if (!String(desa).trim()) continue;
    rows.push({ desa: String(desa).trim(), kecamatan: String(kecamatan).trim(), nilai });
  }
  return rows;
}

/** Agregasi nilai per kecamatan (jumlah baris CSV per kecamatan). */
export function aggregateCsvByKecamatan(rows) {
  const m = new Map();
  rows.forEach((r) => {
    const k = normMap(r.kecamatan || '');
    if (!k) return;
    m.set(k, (m.get(k) || 0) + (Number(r.nilai) || 0));
  });
  return m;
}

export function csvRowsToDesaLookup(rows) {
  const m = new Map();
  rows.forEach((r) => {
    const dk = normMap(r.desa);
    if (dk) m.set(dk, r);
  });
  return m;
}
